var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStory(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.4525 3.51C14.2813 3.38663 14.0834 3.30536 13.8749 3.27279C13.6664 3.24021 13.4532 3.25724 13.2525 3.3225C12.7231 3.47136 12.1748 3.54211 11.625 3.5325C10.8125 3.4884 10.0157 3.28985 9.27751 2.9475C8.36553 2.52572 7.37906 2.28867 6.37501 2.25C4.20751 2.25 3.37501 3 3.22501 3.105C3.15324 3.17534 3.09634 3.25939 3.05769 3.35216C3.01904 3.44492 2.99943 3.54451 3.00001 3.645V15C3.00001 15.1989 3.07903 15.3897 3.21968 15.5303C3.36034 15.671 3.5511 15.75 3.75001 15.75C3.94893 15.75 4.13969 15.671 4.28034 15.5303C4.42099 15.3897 4.50001 15.1989 4.50001 15V11.775C5.09763 11.5462 5.73561 11.4416 6.37501 11.4675C7.18757 11.5116 7.98428 11.7101 8.72251 12.0525C9.6345 12.4743 10.621 12.7113 11.625 12.75C12.5291 12.7841 13.4286 12.6043 14.25 12.225C14.4714 12.121 14.6591 11.9569 14.7917 11.7513C14.9243 11.5458 14.9965 11.3071 15 11.0625V4.5825C14.9997 4.37323 14.95 4.16699 14.8549 3.9806C14.7597 3.79421 14.6218 3.63296 14.4525 3.51Z",
    fill: "#00B47B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStory);
export default __webpack_public_path__ + "static/media/story.7724f4c72751fbe9296022b6f0601d90.svg";
export { ForwardRef as ReactComponent };